import React from 'react';
import { FieldProps, getIn } from 'formik';
import { Checkbox, InputAdornment, MenuItem, Select, TextField, TextFieldProps } from '@mui/material';
import assets from '../../../assets';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker} from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';



export const FormDateFromPicker: React.FC<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
    
    const { error, helperText, field, form, ...rest } = props
    
      return (

          <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker']}>
          <DatePicker
              label="From"
              value={field.value ? dayjs(field.value) : null}
              sx={{
                margin: '20px',
                '& .MuiInputBase-root': {
                  fontSize: '0.9rem',
                }}}
              onChange={(newValue) => {
                  if (newValue) {
                    form.setFieldValue(field.name, newValue ? dayjs(newValue).toISOString() : "");
                  }
              }}
          />
          </DemoContainer>
          </LocalizationProvider>
      )
    }

export const FormDateToPicker: React.FC<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, ...rest } = props
  
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['DatePicker']}>
        <DatePicker
            label="To"
            value={field.value ? dayjs(field.value) : null}
            sx={{
              margin: '20px',
              '& .MuiInputBase-root': {
                fontSize: '0.9rem',
              }}}
            onChange={(newValue) => {
                if (newValue) {
                  form.setFieldValue(field.name, newValue ? dayjs(newValue).toISOString() : "");
                }
            }}
        />
        </DemoContainer>
        </LocalizationProvider>
    )
  }

  export const FormResultIdTextField: React.FC<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, ...rest } = props
  
    return (
      <TextField
      //   variant="outlined"
        error={error ?? Boolean(isTouched && errorMessage)}
        helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
        {...rest}
        {...field}
        fullWidth
        InputLabelProps={{
          sx: {
            fontSize: '0.9rem',
          },
        }}
        sx={{
          margin: '7px 0',
          '& .MuiInputBase-root': {
            fontSize: '0.9rem',
          },
        }}      
        label="Result ID"
        margin="normal"
        placeholder='Enter full ID'
        autoFocus
      />
    )
  }

  export const FormUserIdTextField: React.FC<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, ...rest } = props
  
    return (
      <TextField
      //   variant="outlined"
        error={error ?? Boolean(isTouched && errorMessage)}
        helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
        {...rest}
        {...field}
        fullWidth
        InputLabelProps={{
          sx: {
            fontSize: '0.9rem',
          },
        }}
        sx={{
          margin: '7px 0',
          '& .MuiInputBase-root': {
            fontSize: '0.9rem',
          },
        }}  
        label="User ID"
        margin="normal"
        placeholder='User identifier entered in app'
        autoFocus
      />
    )
  }

/**
 * Material TextField Component with Formik Support including Errors.
 * Intended to be specified via the `component` prop in a Formik <Field> or <FastField> component.
 * Material-UI specific props are passed through.
 */
export const FormTestTypeTextField: React.FC<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, ...rest } = props
  
    return (
      <TextField
      //   variant="outlined"
        error={error ?? Boolean(isTouched && errorMessage)}
        helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
        {...rest}
        {...field}
        fullWidth
        InputLabelProps={{
          sx: {
            fontSize: '0.9rem',
          },
        }}
        sx={{
          margin: '7px 0',
          '& .MuiInputBase-root': {
            fontSize: '0.9rem',
          },
        }}  
        label="Test Type"
        margin="normal"
        autoFocus
        placeholder='e.g. Pheonix...'
        InputProps={{
      }}
      />
    )
  }


  interface FormTestTypeSelectFieldProps extends FieldProps {
    options: { value: string | number, label: string }[];
  }

  //  Buhlmann Contact Select
  export const FormTestTypeSelectField: React.FC<FormTestTypeSelectFieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, options, type, ...rest } = props
  
    return (
      <TextField
        error={Boolean(isTouched && errorMessage)}
        helperText={(isTouched && errorMessage) ? errorMessage : undefined}
        {...rest}
        {...field}
        fullWidth
        InputLabelProps={{
          sx: {
            fontSize: '0.9rem',
          },
        }}
        sx={{
          margin: '7px 0',
          '& .MuiInputBase-root': {
            fontSize: '0.9rem',
          },
        }}  
        select
        label="Test Types"
      >
           <MenuItem key={0} value={""}>
              <em>&nbsp;</em>
           </MenuItem>
  
        {options.map((option, index) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      
      </TextField>
    )
  }

  interface FormOrganisationSelectFieldProps extends FieldProps {
    options: { value: string | number, label: string }[];
  }

  //  Buhlmann Contact Select
  export const FormOrganisationSelectField: React.FC<FormOrganisationSelectFieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, options, type, ...rest } = props
  
    return (
      <TextField
        error={Boolean(isTouched && errorMessage)}
        helperText={(isTouched && errorMessage) ? errorMessage : undefined}
        {...rest}
        {...field}
        fullWidth
        InputLabelProps={{
          sx: {
            fontSize: '0.9rem',
          },
        }}
        sx={{
          margin: '7px 0',
          '& .MuiInputBase-root': {
            fontSize: '0.9rem',
          },
        }}  
        select
        label="Organisation"
      >
           <MenuItem key={0} value={""}>
              <em>&nbsp;</em>
           </MenuItem>
  
        {options.map((option, index) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      
      </TextField>
    )
  }
  
/**
 * Material TextField Component with Formik Support including Errors.
 * Intended to be specified via the `component` prop in a Formik <Field> or <FastField> component.
 * Material-UI specific props are passed through.
 */
export const FormLotNumberTextField: React.FC<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, ...rest } = props
  
    return (
      <TextField
      //   variant="outlined"
        error={error ?? Boolean(isTouched && errorMessage)}
        helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
        {...rest}
        {...field}
        fullWidth
        InputLabelProps={{
          sx: {
            fontSize: '0.9rem',
          },
        }}
        sx={{
          margin: '7px 0',
          '& .MuiInputBase-root': {
            fontSize: '0.9rem',
          },
        }}  
        label="Lot Number"
        margin="normal"
        placeholder='e.g. AB12/3'
        autoFocus
        InputProps={{
      }}
      />
    )
  }


    /**
     * Material TextField Component with Formik Support including Errors.
     * Intended to be specified via the `component` prop in a Formik <Field> or <FastField> component.
     * Material-UI specific props are passed through.
     */
    export const FormSampleIDTextField: React.FC<FieldProps & TextFieldProps> = props => {
        const isTouched = getIn(props.form.touched, props.field.name)
        const errorMessage = getIn(props.form.errors, props.field.name)
    
        const { error, helperText, field, form, ...rest } = props
    
        return (
        <TextField
        //   variant="outlined"
            error={error ?? Boolean(isTouched && errorMessage)}
            helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
            {...rest}
            {...field}
            fullWidth
            InputLabelProps={{
              sx: {
                fontSize: '0.9rem',
              },
            }}
            sx={{
              margin: '7px 0',
              '& .MuiInputBase-root': {
                fontSize: '0.9rem',
              },
            }}  
            label="Sample ID"
            margin="normal"
            placeholder='e.g. SampleIDD1'
            autoFocus
            InputProps={{
        }}
        />
        )
    }

  export const FormSampleTypeTextField: React.FC<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, ...rest } = props
  
    return (
      <TextField
      //   variant="outlined"
        error={error ?? Boolean(isTouched && errorMessage)}
        helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
        {...rest}
        {...field}
        fullWidth
        InputLabelProps={{
          sx: {
            fontSize: '0.9rem',
          },
        }}
        sx={{
          margin: '7px 0',
          '& .MuiInputBase-root': {
            fontSize: '0.9rem',
          },
        }}  
        label="Sample Type"
        margin="normal"
        placeholder='e.g. SampleType1'
        autoFocus
        InputProps={{
      }}
      />
    )
  }

  export const FormVisualResultTextField: React.FC<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, ...rest } = props
  
    return (
      <TextField
      //   variant="outlined"
        error={error ?? Boolean(isTouched && errorMessage)}
        helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
        {...rest}
        {...field}
        fullWidth
        InputLabelProps={{
          sx: {
            fontSize: '0.9rem',
          },
        }}
        sx={{
          margin: '7px 0',
          '& .MuiInputBase-root': {
            fontSize: '0.9rem',
          },
        }}  
        label="Visual Result"
        margin="normal"
        placeholder='e.g. Positive'
        autoFocus
        InputProps={{
      }}
      />
    )
  }

  export const FormSkipTextField: React.FC<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, ...rest } = props
  
    return (
      <TextField
      //   variant="outlined"
        error={error ?? Boolean(isTouched && errorMessage)}
        helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
        {...rest}
        {...field}
        fullWidth
        InputLabelProps={{
          sx: {
            fontSize: '0.9rem',
          },
        }}
        sx={{
          margin: '7px 0',
          '& .MuiInputBase-root': {
            fontSize: '0.9rem',
          },
        }}  
        label="Skip"
        margin="normal"
        placeholder='e.g. 50 (Skip first 50 items)'
        autoFocus
        InputProps={{
      }}
      />
    )
  }

  export const FormLimitTextField: React.FC<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, ...rest } = props
  
    return (
      <TextField
      //   variant="outlined"
        error={error ?? Boolean(isTouched && errorMessage)}
        helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
        {...rest}
        {...field}
        fullWidth
        InputLabelProps={{
          sx: {
            fontSize: '0.9rem',
          },
        }}
        sx={{
          margin: '7px 0',
          '& .MuiInputBase-root': {
            fontSize: '0.9rem',
          },
        }}  
        label="Limit"
        margin="normal"
        placeholder='e.g. 100 (Only fetch 100 items)'
        autoFocus
        InputProps={{
      }}
      />
    )
  }

  export const FormAppliedFiltersTextField: React.FC<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name)
    const errorMessage = getIn(props.form.errors, props.field.name)
  
    const { error, helperText, field, form, ...rest } = props
  
    return (
      <TextField
      //   variant="outlined"
        error={error ?? Boolean(isTouched && errorMessage)}
        helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
        {...rest}
        {...field}
        fullWidth
        label="Enter new filter name"
        margin="none"
        placeholder='e.g. My new filter'
        autoFocus
        autoComplete="off"

        InputProps={{
          sx: {
              height: '32px',
              padding: '0 14px',
              'input': {
                  height: '1.1876em',
                  padding: '5px 0'
              }
          },
        }}
        sx={{
            margin: '9.8px 0',
            height: '35px',
            '& .MuiInputBase-root': {
                height: '100%',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: '1px solid',
            },
        }}
        InputLabelProps={{
          sx: {
            top: '-7px'
          }
        }}
        variant="outlined"
      />
    )
  }
